import React, { useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Checkbox,
    Select,
    MenuItem,
    IconButton,
    Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ToastContainer } from 'react-toastify';


const MeetingInvite = ({ }) => {
    const [openInviteModal, setOpenInviteModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [token, setToken] = useState(sessionStorage.getItem("token") || "");
    const [selectedResourceTypes, setSelectedResourceTypes] = useState([]);
    const resourceTypes = ["Resource Type 1", "Resource Type 2", "Resource Type 3"];
    const [filteredData, setFilteredData] = useState([]);
    const [formData, setFormData] = useState({

    });
    const departments = [
        "Department of Agriculture",
        "Department of Animal Husbandry and Dairying",
        "Department of Art and culture",
        "Department of Chemicals & Petrochemicals",
        "Department of Disaster Management",
        "Department of Drinking Water",
    ];
    const [formErrors, setFormErrors] = useState({
        designation: "",
        mobile_no: "",
        full_name: "",
        email: "",
        entity_name: "",
        entity_type: "",
        district: "",
        block: "",
        gram_panchayat: "",
    });
    const [options, setOptions] = useState([
        "WPPFT",
        "GPPFT",
        "Bal Sabha",
        "Mahila Sabha",
        "Line Department Details",
        "Facilitator As Resource Person"
    ]);
    const [rows, setRows] = useState([
        {
            districtName: "AMBALA",
            gramPanchayatName: "AMBALA-I",
            blockName: "AHEMA",
            sabhaDate: "2024-09-20",
            startTime: "10:00 AM",
            endTime: "11:00 AM",
            officialRepName: "Rep Name",
            officialRepPhone: "1234567890",
            sarpanchName: "Sarpanch Name",
            sarpanchMobile: "0987654321",
            panchayatAddress: "123 Address St.",
            panchayatPincode: "123456",
            agenda: "Meeting Agenda",
        },
        {
            districtName: "BHIWANI",
            gramPanchayatName: "AMBALA-II",
            blockName: "AMIPUR",
            sabhaDate: "2024-09-20",
            startTime: "10:00 AM",
            endTime: "11:00 AM",
            officialRepName: "Karan",
            officialRepPhone: "1234567890",
            sarpanchName: "Sarpanch Name",
            sarpanchMobile: "0987654321",
            panchayatAddress: "123 Address St.",
            panchayatPincode: "123456",
            agenda: "Meeting Agenda",
        },
        {
            districtName: "FARIDABAD",
            gramPanchayatName: "BARARA",
            blockName: "ANANDPUR",
            sabhaDate: "2024-09-20",
            startTime: "10:00 AM",
            endTime: "11:00 AM",
            officialRepName: "Akash",
            officialRepPhone: "1234567890",
            sarpanchName: "Sarpanch Name",
            sarpanchMobile: "0987654321",
            panchayatAddress: "123 Address St.",
            panchayatPincode: "123456",
            agenda: "Meeting Agenda",
        },
        {
            districtName: "HISAR",
            gramPanchayatName: "SAHA",
            blockName: "BARA",
            sabhaDate: "2024-09-20",
            startTime: "10:00 AM",
            endTime: "11:00 AM",
            officialRepName: "Rep Name",
            officialRepPhone: "1234567890",
            sarpanchName: "Rohit",
            sarpanchMobile: "0987654321",
            panchayatAddress: "123 Address St.",
            panchayatPincode: "123456",
            agenda: "Meeting Agenda",
        },
        {
            districtName: "JIND",
            gramPanchayatName: "SHAHZADPUR",
            blockName: "BHARI",
            sabhaDate: "2024-09-20",
            startTime: "10:00 AM",
            endTime: "11:00 AM",
            officialRepName: "Adarsh",
            officialRepPhone: "1234567890",
            sarpanchName: "Sarpanch Name",
            sarpanchMobile: "0987654321",
            panchayatAddress: "123 Address St.",
            panchayatPincode: "123456",
            agenda: "Meeting Agenda",
        },

    ]);
    const handleInvite = (row, index) => {
        setSelectedRow(row);
        setOpenInviteModal(true);
    };

    const handleChange = (event) => {
        const { name, id, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
        setFormErrors(prevErrors => ({
            ...prevErrors,
            [id]: false
        }));

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

    };


    return (
        <div className="container-fluid mt-3" style={{ height: "91vh", overflowY: "auto" }}>
<h2 className="pt-10" style={{ top: "0", left: "0", margin: "16px",fontWeight:"bold"}}>                Meeting Invite
            </h2>
            <TableContainer component={Paper} style={{ overflowX: 'auto',maxHeight: '70vh', marginTop: '20px' }}>
            <Table aria-label="simple table" >
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "rgb(179 220 224)",
                  }}
                >
                        <TableRow>
                            <TableCell>DISTRICT NAME</TableCell>
                            <TableCell>GRAMPANCHAYAT NAME</TableCell>
                            <TableCell>BLOCK NAME</TableCell>
                            <TableCell>SABHA DATE</TableCell>
                            <TableCell>START TIME</TableCell>
                            <TableCell>END TIME</TableCell>
                            <TableCell>OFFICIAL REPRESENTATIVE NAME</TableCell>
                            <TableCell>OFFICIAL REPRESENTATIVE PHONE</TableCell>
                            <TableCell>SARPANCH NAME</TableCell>
                            <TableCell>SARPANCH MOBILE NUMBER</TableCell>
                            <TableCell>PANCHAYT ADDRESS</TableCell>
                            <TableCell>PANCHAYT PINCODE</TableCell>
                            <TableCell>AGENDA</TableCell>
                            <TableCell>INVITE</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.districtName}</TableCell>
                                <TableCell>{row.gramPanchayatName}</TableCell>
                                <TableCell>{row.blockName}</TableCell>
                                <TableCell>{row.sabhaDate}</TableCell>
                                <TableCell>{row.startTime}</TableCell>
                                <TableCell>{row.endTime}</TableCell>
                                <TableCell>{row.officialRepName}</TableCell>
                                <TableCell>{row.officialRepPhone}</TableCell>
                                <TableCell>{row.sarpanchName}</TableCell>
                                <TableCell>{row.sarpanchMobile}</TableCell>
                                <TableCell>{row.panchayatAddress}</TableCell>
                                <TableCell>{row.panchayatPincode}</TableCell>
                                <TableCell>{row.agenda}</TableCell>
                                <TableCell>
                                    <button
                                        onClick={() => handleInvite(row)}
                                        style={{ backgroundColor: "#4CAF50", color: "white", border: "none", padding: "5px 10px", cursor: "pointer" }}
                                    >
                                        Invite
                                    </button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <ToastContainer />




            <div className="Container mt-3">
                {/* Your existing table code here */}

                <Dialog
                    open={openInviteModal}
                    onClose={() => setOpenInviteModal(false)}
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle>
                        Invite Resource
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setOpenInviteModal(false)}
                            aria-label="close"
                            style={{ position: "absolute", right: 15, top: 7 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div className="row g-3">
                            {/* <div className="col-md-4">
                                <label className="form-label" style={{ fontWeight: "800" }}>District Code</label>
                                <input type="text" className="form-control" value={58} readOnly />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label" style={{ fontWeight: "800" }}>Block Code</label>
                                <input type="text" className="form-control" value={1030} readOnly />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label" style={{ fontWeight: "800" }}>Village Code</label>
                                <input type="text" className="form-control" value={27783} readOnly />
                            </div> */}

                            <div className="col-md-4 mb-3">
                                <label htmlFor="resourceType" className="form-label" style={{ fontWeight: "600" }}>
                                    Resource Type
                                </label>
                                <Multiselect
                                    options={options}
                                    isObject={false}
                                    onSelect={(event) => setSelectedResourceTypes(Array.from(new Set([...selectedResourceTypes, ...event])))}
                                    onRemove={(event) => setSelectedResourceTypes(selectedResourceTypes.filter(opt => !event.includes(opt)))}
                                />
                                {formErrors.resourceType && <div className="invalid-feedback">Resource Type is required.</div>}
                            </div>

                            {selectedResourceTypes.map((option, index) => (
                                <div className="col-md-4" key={index}>
                                    <label htmlFor={option} className="form-label" style={{ fontWeight: "600" }}>
                                        {option}
                                    </label>
                                    <select
                                        className={`form-select ${formErrors.entity_type ? "is-invalid" : ""}`}
                                        name="entity_type"
                                        id="entity_type1"
                                        value={formData.entity_type || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>
                                           Select Resource Name
                                        </option>
                                        {filteredData.map((item, index) => (
                                            <option key={index} value={item.entity_code}>
                                                {item.full_name}
                                            </option>
                                        ))}
                                    </select>
                                    {formErrors.entity_type && (
                                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                                            {formErrors.entity_type}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Table Below the Dropdowns */}
                        <TableContainer style={{ maxWidth: "100%", maxHeight: "400px", marginTop: "20px" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ padding: "15px", width: "80px" }}>Sr. No</TableCell>
                                        <TableCell style={{ padding: "30px" }}>Department Name</TableCell>
                                        <TableCell style={{ padding: "30px" }}>Frontline Workers Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {departments.map((department, index) => (
                                        <TableRow key={index} style={{ height: "20px" }}>
                                            <TableCell style={{ width: "80px" }}>
                                                <Checkbox />
                                            </TableCell>
                                            <TableCell>{department}</TableCell>
                                            <TableCell>
                                                <Select
                                                    fullWidth
                                                    variant="outlined"
                                                    defaultValue=""
                                                    style={{
                                                        height: "50px",
                                                        borderRadius: "10px",
                                                    }}
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: 200,
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="">Select</MenuItem>
                                                    <MenuItem value="1">Option 1</MenuItem>
                                                    <MenuItem value="2">Option 2</MenuItem>
                                                    <MenuItem value="3">Option 3</MenuItem>
                                                </Select>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                variant="contained"
                                onClick={() => setOpenInviteModal(false)}
                                style={{
                                    marginRight: "10px",
                                    backgroundColor: "#323576",
                                    color: "#ffffff",
                                    width: "12%",
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: "#323576",
                                    color: "#ffffff",
                                    width: "12%",
                                }}
                            >
                                Send Invite
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        </div>
    );
};

export default MeetingInvite;
